import React, { useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Sidebar/Dark_logo.png";
import facebookIcon from "../../assets/Icons/facebook.svg";
import googleIcon from "../../assets/Icons/google.svg";
import appleIcon from "../../assets/Icons/apple.svg";
import blueBg from "../../assets/Login/bluebg.svg";
import loginImage from "../../assets/Login/image1.png";
import LoginImageMobile from "../../assets/Login/mobilebg.svg";
import LoginImageTab from "../../assets/Login/bluebg-tabs.png";
import avatar from "../../assets/Icons/user-avatar.png";
import edit from "../../assets/Icons/fluent_edit.svg";
import { useThunk } from "../../hooks/useThunk";
import useForm from "../../hooks/useForm";
import { signup } from "../../store";
import showToast from "../../utils/toastNotifications";
import { USER_INPUT_FIELD_TYPES } from "../../constants/userInputFieldNames";
import LoginInput from "../../components/Form/LoginInput";
import LoginButton from "../../components/Form/LoginButton";
import ButtonSpinner from "../../components/loading/ButtonSpinner";
import { getGoogleAuthUrl } from "../../utils/googleAuth";
import useFirebaseFileUpload from "../../hooks/useFirebaseFileUpload";
import { errorMessages } from "../../constants/frontendErrorMessages";

const SignUp = () => {
  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
  } = useForm(
    {
      firstName: "",
      lastName: "",
      email: "",
      // phoneNumber: "",
      password: "",
      confirmPassword: "",
    },
    {
      firstName: true,
      lastName: true,
      email: true,
      // phoneNumber: true,
      password: true,
      confirmPassword: true,
    },
    {
      firstName: USER_INPUT_FIELD_TYPES.FIRST_NAME,
      lastName: USER_INPUT_FIELD_TYPES.LAST_NAME,
      email: USER_INPUT_FIELD_TYPES.EMAIL,
      // phoneNumber: USER_INPUT_FIELD_TYPES.PHONE,
      password: USER_INPUT_FIELD_TYPES.PASSWORD,
      confirmPassword: USER_INPUT_FIELD_TYPES.CONFIRM_PASSWORD,
    }
  );

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [doSignup, isSigningUp] = useThunk(signup);
  const [uploadedImage, setUploadedImage] = useState(null); // State for uploaded image
  const [doUpload, isUploadingImage] = useFirebaseFileUpload();
  const fileInputRef = useRef(null); // Ref for the hidden file input

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      firstName: true,
      lastName: true,
      email: true,
      // phoneNumber: true,
      password: true,
      confirmPassword: true,
    });

    if (!isTermsAccepted) {
      showToast("caution", "You Must Accept The Terms And Conditions");
      return;
    }

    if (validateForm()) {
      let updatedFormData = { ...formData };

      //upload image if provide
      if (uploadedImage) {
        const uploadResult = await doUpload(
          [uploadedImage],
          "user/profilePicture"
        );
        if (!uploadResult.success) {
          showToast("error", uploadResult?.error?.message || "Failed to upload files");
          return;
        }
        updatedFormData.profilePicture = uploadResult?.uploadedUrls[0];
      }

      const result = await doSignup(updatedFormData);

      if (result.success) {
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          // phoneNumber: "",
          password: "",
          confirmPassword: "",
        });
        localStorage.setItem("token", result.response.data.token);
        showToast("success", "Sign Up Sucessfull");
        navigate("/"); // navigate to dashbord
      } else {
        showToast("error", result.error.message);
      }
    }
  };

  // redirect user to google concent screen
  const handleGoogleSignin = (e) => {
    e.preventDefault();
    const authUrl = getGoogleAuthUrl();
    if (!authUrl) {
      showToast("error", errorMessages.FAILED_GOOGLE_SIGNIN);
      return;
    }
    window.location.href = authUrl;
  };

  const handleEditImageClick = () => {
    fileInputRef.current.click(); // Trigger click on the hidden file input
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
    }
  };

  return (
    <div className="flex flex-col min-w-[403px] relative w-full h-screen overflow-x-hidden">
      {/* WatermarkBg*/}
      <div className="lg:hidden absolute right-0 w-[60%]">
        <img
          src={LoginImageMobile}
          alt="background"
          className="sm:hidden w-full"
        />
        <img
          src={LoginImageTab}
          alt="background"
          className="hidden sm:block ml-[40px] w-full"
        />
      </div>

      <div className="absolute z-0 top-0 right-0 w-full login-br:block">
        <img
          src={blueBg}
          alt="background"
          className="hidden lg:block absolute -right-15 -top-20 lg:right-0 w-full  lg:max-w-[650px] xl:max-w-[700px] 2xl:max-w-[750px] 1920-br:max-w-[850px] 2560-br:max-w-[1400px] transition-all duration-300"
        />
      </div>

      {/* Form Container-left  */}
      <div className="relative z-10 mx-auto mt-16 pb-10 flex flex-grow items-start lg:items-center justify-center login-br:justify-between w-full 2xl:max-w-[1536px] auth-layout-structure-in-tab-screen-higher-than-880-height">
        <div className="w-full lg:w-[90%] 2xl:w-[60%] flex flex-col justify-center px-10 lg:px-20 ml-0 1920-br:translate-x-[80px]">
          <div className="flex flex-col sm:flex-row-reverse sm:justify-end">
            <img
              src={logo}
              alt="Main"
              className="sm:ml-[12px] mb-5 sm:mb-0 px-[8px] h-[40px] w-[150px] sm:w-auto"
              />
            <h1 className="text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2 sm:mb-4">
              Sign Up
            </h1>
          </div>
          <p className="mb-0 sm:mb-10 font-inter text-[18px] text-gray max-w-[200px] sm:max-w-[300px] md:max-w-none">
            Please login to continue to your account.
          </p>

          <form
            onSubmit={handleSubmit}
            className="w-full sm:max-lg:w-[55%] max-sm:mt-10"
          >
            <div>
              {/* Profile Picture */}

              {uploadedImage ? (
                <div className="relative">
                  <div
                    className="rounded-full w-8 h-8 bg-primary absolute left-[102px] top-[97px] items-center justify-center"
                    onClick={handleEditImageClick}
                  >
                    <img
                      src={edit}
                      alt="imgEdit"
                      className="items-center justify-center p-[6px] cursor-pointer"
                    />
                  </div>
                  <img
                    src={URL.createObjectURL(uploadedImage)}
                    alt="Uploaded"
                    className="w-[120px] h-[120px] object-cover rounded-[5px] mt-3 border border-secondary"
                  />
                </div>
              ) : (
                <div>
                  <div className="border border-secondary w-[120px] h-[120px] rounded-[5px] mt-3">
                    <img
                      src={avatar}
                      alt="useravatar"
                      onClick={handleEditImageClick}
                      className=" cursor-pointer p-[6px] rounded-[5px] w-[120px] h-[120px] items-center justify-center"
                    />
                    <img
                      src={edit}
                      alt="imgEdit"
                      onClick={handleEditImageClick}
                      className=" cursor-pointer p-[6px] rounded-full w-auto h-8 bg-primary relative left-[100px] top-[-20px] items-center justify-center"
                    />
                  </div>
                </div>
              )}
              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                className="hidden"
                onChange={handleImageChange}
              />

              {/* First Name and Last Name */}
              <div className="grid grid-cols-1 1440-br:grid-cols-2 md:gap-1 1440-br:gap-6 sm:mr-10 lg:mr-0 mt-6">
                <LoginInput
                  className="px-4"
                  id="firstName"
                  name="firstName"
                  label="First Name"
                  value={formData.firstName}
                  placeholder="Enter your first name"
                  error={touched.firstName && errors.firstName}
                  onChange={(e) =>
                    handleInputChange("firstName", e.target.value)
                  }
                  onBlur={() => handleBlur("firstName", formData.firstName)}
                />
                <LoginInput
                  className="px-4"
                  id="lastName"
                  name="lastName"
                  label="Last Name"
                  value={formData.lastName}
                  placeholder="Enter your last name"
                  error={touched.lastName && errors.lastName}
                  onChange={(e) =>
                    handleInputChange("lastName", e.target.value)
                  }
                  onBlur={() => handleBlur("lastName", formData.lastName)}
                />
              </div>

              {/* Email and Phone */}
              <div className="grid grid-cols-1 md:gap-1 1440-br:gap-6 sm:mr-10 lg:mr-0">
                <LoginInput
                  className="px-4"
                  id="email"
                  name="email"
                  label="Email Address"
                  type="email"
                  value={formData.email}
                  placeholder="Enter your email address"
                  error={touched.email && errors.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  onBlur={() => handleBlur("email", formData.email)}
                />
              </div>

              {/* Password and Confirm Password */}
              <div className="grid grid-cols-1 1440-br:grid-cols-2 md:gap-1 1440-br:gap-6 sm:mr-10 lg:mr-0">
                <LoginInput
                  className="px-4"
                  id="password"
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  placeholder="Enter your password"
                  error={touched.password && errors.password}
                  showPasswordToggle
                  isPasswordVisible={showPassword}
                  togglePasswordVisibility={() =>
                    setShowPassword(!showPassword)
                  }
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                  onBlur={() => handleBlur("password", formData.password)}
                />
                <LoginInput
                  className="px-4"
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  value={formData.confirmPassword}
                  placeholder="Confirm your password"
                  error={touched.confirmPassword && errors.confirmPassword}
                  showPasswordToggle
                  isPasswordVisible={showConfirmPassword}
                  togglePasswordVisibility={() =>
                    setShowConfirmPassword(!showConfirmPassword)
                  }
                  onChange={(e) =>
                    handleInputChange("confirmPassword", e.target.value)
                  }
                  onBlur={() =>
                    handleBlur("confirmPassword", formData.confirmPassword)
                  }
                />
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="flex items-center justify-center mt-8 mb-4 sm:mr-10 lg:mr-0">
              <input
                type="checkbox"
                checked={isTermsAccepted}
                onChange={(e) => setIsTermsAccepted(e.target.checked)}
                className="w-4 h-4 accent-[#6D758F] rounded"
              />
              <span className="ml-2 text-sm text-[#6D758F]">
                I have read and agree to the{" "}
                <a href="https://coursepivot.com/terms-and-conditions/" className="text-[#6D758F] underline">
                  Terms and Conditions
                </a>
              </span>
            </div>

            <div className="flex flex-col items-center justify-center sm:mr-10 lg:mr-0">
              {/* Sign-Up Button */}
              <LoginButton
                text={
                  isSigningUp || isUploadingImage ? (
                    <ClipLoader
                      loading={isSigningUp || isUploadingImage}
                      speedMultiplier={1}
                      size={22}
                      color="#60a5fa"
                    />
                  ) : (
                    "Sign Up"
                  )
                }
                type="submit"
                className="max-w-[480px] py-3 h-[54px]"
                onClick={handleSubmit}
                disabled={isSigningUp || isUploadingImage}
              />

              {/* Sign-In Link */}
              <p className="mt-3 font-lato text-[15px] text-center leading-[18.75px] text-black/50">
                Already have an account?{" "}
                <a href="/signin" className="text-blue-shades hover:underline">
                  Sign In
                </a>
              </p>

              {/* social logins */}
              <div className="flex mt-8 w-full max-w-[480px]">
                <div className="w-full max-w-[480px]">
                  <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-medium-gray"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 font-inter font-medium text-level-3 leading-[24px] text-gray bg-white">
                        or
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 h-[54px] gap-4 mt-6">
                    {/* <button
                      className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                      disabled={isSigningUp || isUploadingImage}
                      type="button"
                    >
                      <img
                        src={facebookIcon}
                        alt="Facebook"
                        className="w-5 h-5"
                      />
                    </button> */}
                   <button
                      className="flex items-center justify-center gap-3 font-inter font-semibold text-[18px] leading-[21.6px] text-gray py-3 rounded-lg hover:bg-[#EFEFEF] transition duration-200 px-4 py-2 border rounded-md border-medium-gray "
                      onClick={handleGoogleSignin}
                      disabled={isSigningUp || isUploadingImage}
                    >
                      <img src={googleIcon} alt="Google" className="w-5 h-5" />
                      <span>Continue with Google</span>
                    </button>
                    {/* <button
                      className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                      disabled={isSigningUp || isUploadingImage}
                      type="button"
                    >
                      <img src={appleIcon} alt="Apple" className="w-5 h-5" />
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        {/* Right Side: Image */}
        <div className="hidden lg:flex items-center justify-center w-full md:max-w-[480px] lg:max-w-[580px] xl:max-w-[650px] max-1440-br:-translate-y-32 1920-br:-translate-x-[80px]">
          <img src={loginImage} alt="Sign Up" />
        </div>
      </div>
    </div>
  );
};

export default SignUp;

{/* <LoginInput
  className="px-4"
  id="phoneNumber"
  name="phoneNumber"
  label="Phone Number"
  type="tel"
  value={formData.phoneNumber}
  placeholder="Enter your phone number"
  error={touched.phoneNumber && errors.phoneNumber}
  onChange={(e) =>
    handleInputChange("phoneNumber", e.target.value)
  }
  onBlur={() => handleBlur("phoneNumber", formData.phoneNumber)}
/> */}
